<template>
  <div class="container mx-auto my-10 p-4">
    <div class="w-full flex place-content-center">
      <div class="w-1/2 p-4 text-center">
        <div class="card-header p-4">
          <h2>{{ _page.title }}</h2>
        </div>
        <div class="card-body p-4" v-show="_page.content" v-html="_page.content">
        </div>
        <p>My new Life brings science to you and your body, to live better for longer.</p>
        <p>Please complete the following information for us to work on your personalised solution. All information provided in your self-assessment is Totally Confidential. Data Transfers are encrypted.</p>

        <div class="flex flex-wrap bg-white rounded-md p-4 shadow-lg">
          <TextInput
            class="w-full"
            :label="language == 'en' ? 'Your Name' : '您的姓名'"
            name="name"
            id="name"
            v-model="user.name"
          />

          <TextInput
            class="w-full"
            label="Email address"
            name="email"
            id="email"
            :error="emailError"
            v-model="user.email"
          />

          <TextInput
            class="w-full"
            label="Agent ID"
            name="agentId"
            id="agentId"
            v-model="user.agentId"
            :disabled="disableAgentId"
          />

          <Button
            class="w-full"
            type="submit"
            id="register-submit"
            :label="language == 'en' ? 'Next' : '下一步'"
            v-on:click="handleSubmit"
          />
          <p class="w-full">If you have already submitted an assessment, please <a class="w-full" href="/login">login</a>.</p>
          <p class="w-full">If you do not know your password you can use the <a class="w-full" href="/password/reset">
            forgotten password</a> link.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import TextInput from "./forms/TextInput";
import Button from "./forms/Button";

export default {
  data() {
    return {
      user: {
        name: "",
        email: "",
        agentId: ""
      },
      emailError: null,
      disableAgentId: false
    };
  },
  props: ["page"],

  computed: {
    ...mapGetters({
      language: "clientLanguage"
    }),
    _page() {
      return JSON.parse(this.page);
    },
    email() {
      return this.user.email;
    }
  },
  components: {
    TextInput,
    Button
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.user.agentId = urlParams.get("agent_id");
    if (this.user.agentId != null) {
      this.disableAgentId = true;
    }
  },
  watch: {
    async email() {
      let response = await axios.post("/register/check-email", {email: this.email});

      if(response.data.success) {
        this.emailError = null;
      }
      else {
        this.emailError = "Email already in use."
      }
    }
  },
  methods: {
    handleSubmit() {
      if(this.emailError) {
        return;
      }
      this.$store
        .dispatch("postRegistration", this.user)
        .then(res => {
          this.$store.dispatch("createAssessment").then(() => {
            window.location.href = "/assessment";
          });
        })
        .catch(error => {
          console.error(error);
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .w-1\/2 {
    width: 100%;
  }
}
</style>
